var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f36ddec1-51df-4aba-a33f-b5313eb7fca6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-abe1054e-5dc7-409d-a6c7-fa9ae145bbaa {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-abe1054e-5dc7-409d-a6c7-fa9ae145bbaa",
    d: "M21.99,11.6h-3.58l-.3-.59c-.17-.33-.51-.54-.89-.54h-7.21c-.55,0-1,.45-1,1v9.07c0,.55.45,1,1,1h11.98c.55,0,1-.45,1-1v-7.93c0-.55-.45-1-1-1ZM20.99,19.54h-9.98v-7.07h5.6l.3.59c.17.33.51.54.89.54h3.19v5.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-abe1054e-5dc7-409d-a6c7-fa9ae145bbaa",
    d: "M16.2,15.31h-.86v-.86c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.86h-.86c-.41,0-.75.34-.75.75s.34.75.75.75h.86v.86c0,.41.34.75.75.75s.75-.34.75-.75v-.86h.86c.41,0,.75-.34.75-.75s-.34-.75-.75-.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFolder);
export default __webpack_public_path__ + "static/media/NewFolder.033d251981d901f89e1d89fac14ba358.svg";
export { ForwardRef as ReactComponent };